<template>
    <div class="form-page">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "form-page"
    }
</script>

<style lang="scss" scoped>
    .form-page {
        background: #f8f8f8;
        padding: 1.25rem;
        border-radius: 0.25rem;
        margin-bottom: 1.25rem;
    }
</style>
